import {
  ITERATE_TYPE_KEYS,
  ITERATE_TYPE_VALUES,
  ITERATOR_SYMBOL_REAL,
  ITERATOR_SYMBOL_FAUX
} from './imconst.js'

class Iterator {
  constructor(next) {
    if (next) {
      // Map extends Iterator and has a `next` method,
      // do not erase it in that case.
      // We could have checked `if (next && !this.next)` too.
      this.next = next
    }
  }
}

const iteratorValue = (type, k, v, iteratorResult) => {
  const value = type === ITERATE_TYPE_KEYS
    ? k
    : type === ITERATE_TYPE_VALUES ? v : [k, v]

  iteratorResult
    ? (iteratorResult.value = value)
    : (iteratorResult = {
      value: value,
      done: false
    })
  return iteratorResult
}

const iteratorDone = () => {
  return { value: undefined, done: true }
}

const getIteratorFn = iterable => {
  const iteratorFn =
    iterable &&
    ((ITERATOR_SYMBOL_REAL && iterable[ITERATOR_SYMBOL_REAL]) ||
      iterable[ITERATOR_SYMBOL_FAUX])
  if (typeof iteratorFn === 'function') {
    return iteratorFn
  }
}

const iteratorGet = iterable => {
  const iteratorFn = getIteratorFn(iterable)
  return iteratorFn && iteratorFn.call(iterable)
}

const mapIteratorValue = (type, entry) => (
  iteratorValue(type, entry[0], entry[1]))

const mapIteratorFrame = (node, prev) => ({
  node: node,
  index: 0,
  __prev: prev
})

class IteratorMap extends Iterator {
  constructor(map, type, reverse) {
    super()

    this._type = type
    this._reverse = reverse
    this._stack = map._root && mapIteratorFrame(map._root)
  }

  next() {
    const type = this._type
    let stack = this._stack
    while (stack) {
      const node = stack.node
      const index = stack.index++
      let maxIndex
      if (node.entry) {
        if (index === 0) {
          return mapIteratorValue(type, node.entry)
        }
      } else if (node.entries) {
        maxIndex = node.entries.length - 1
        if (index <= maxIndex) {
          return mapIteratorValue(
            type,
            node.entries[this._reverse ? maxIndex - index : index]
          )
        }
      } else {
        maxIndex = node.nodes.length - 1
        if (index <= maxIndex) {
          const subNode = node.nodes[this._reverse ? maxIndex - index : index]
          if (subNode) {
            if (subNode.entry) {
              return mapIteratorValue(type, subNode.entry)
            }
            stack = this._stack = mapIteratorFrame(subNode, stack)
          }
          continue
        }
      }
      stack = this._stack = this._stack.__prev
    }
    return iteratorDone()
  }
}

export {
  Iterator,
  iteratorValue,
  iteratorDone,
  iteratorGet,
  IteratorMap
}
